import React, { useContext } from 'react';
import { ActivityCard } from 'Components/widgets/activity-card/ActivityCard';
import { Columns } from 'Components/frameworks/columns/Columns';
import { upSellTypeMapping } from 'Views/booking/booking-confirmation/BookingConfirmationTracking.utils';
import { RentalsCta } from 'Components/widgets/rentals-cta/RentalsCta';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { ServicesContext, type ServicesContextType } from 'Context/ServicesContext';
type Props = {
  activities: Array<ActivityEntity>;
  category: ActivitiesCategoryEntity | ActivitiesThematicEntity;
  colsNumber?: number;
  hasRentals?: boolean;
};
export const ActivitiesList = ({
  activities = [],
  colsNumber = 3,
  category,
  hasRentals = false,
}: Props) => {
  const { trackClickEvent } = useTrackEvent();
  const { bookingId } = useContext(ServicesContext) as ServicesContextType & {
    bookingId?: string;
  };

  if (!activities?.length && !hasRentals) {
    return null;
  }

  return (
    <Columns colsNumber={colsNumber}>
      {hasRentals && category.upsellType === upSellTypeMapping.WINTER_SPORT && (
        <RentalsCta
          className="h-200"
          onClick={() =>
            trackClickEvent(TRACK_EVENT_NAMES.CLICK_ACTIVITIES_SERVICES, {
              detail_click: 'service_ski_equipment',
            })
          }
        />
      )}
      {activities.map((activity) => (
        <ActivityCard
          activity={activity}
          bookingId={bookingId}
          className="mb-20"
          key={activity.id}
        />
      ))}
    </Columns>
  );
};
